// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Default Font Size is 14px on the HTML page, use the below scale to adjust font sizes.

8pt = 0.571rem
10pt = 0.714rem
12pt = 0.857rem
14pt = 1rem (base font size)
18pt = 1.285rem
20pt = 1.428rem
22pt = 1.571rem
24pt = 1.714rem
28pt = 2rem
30pt = 2.142rem
32pt = 2.285rem
*/
/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezClocker Supported Media Screen Sizes
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
/*------------------------------------------------------
| @Media Small Mobile Devices
--------------------------------------------------------*/
/*------------------------------------------------------
| @Media for Regular Mobile Devices
--------------------------------------------------------*/
/*------------------------------------------------------
| @Media for Tablets
--------------------------------------------------------*/
/*------------------------------------------------------
| @Media for Laptops
--------------------------------------------------------*/
/*------------------------------------------------------
| @Media for Desktops
--------------------------------------------------------*/
/* Use http://paletton.com to generate pallets */
.ezBackgroundImage {
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.07) 50%, transparent 50%), linear-gradient(90deg, rgba(255, 255, 255, 0.13) 50%, transparent 50%), linear-gradient(90deg, transparent 50%, rgba(255, 255, 255, 0.17) 50%), linear-gradient(90deg, transparent 50%, rgba(255, 255, 255, 0.19) 50%);
  background-size: 13px, 29px, 37px, 53px;
}

.ez-float-left {
  float: left;
}

.ez-float-right {
  float: left;
}

.ez-bring-to-front {
  z-index: 9999;
}

.ez-hidden {
  display: none;
}

.ez-topish {
  margin-top: 25%;
}

.ez-full-width {
  width: 100%;
}

.ezErrorBox {
  display: none;
  margin-top: 4px;
  margin-bottom: 4px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  padding-left: 28px;
  min-height: 20px;
  min-width: 20px;
  background-color: #ffcccc;
  background-image: url("/public/images/icons/error-red.svg");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position-x: 4px;
  background-position-y: 4px;
  background-clip: padding-box;
  color: #000000;
  font-size: 12pt;
  border-style: solid;
  border-width: 1px;
  border-color: #9b0400;
}

#appleAppStoreBadge {
  height: 46px;
}

div.sign-in {
  margin: 0;
  padding: 0;
}

section {
  background-color: rgba(225, 225, 225, 0.3);
}
section h2.section-heading {
  font-size: 1.714rem;
  margin-top: 15px;
  margin-bottom: 15px;
  color: #000000;
}
section h3.section-subheading {
  color: #0f4777;
  font-size: 1.714rem;
  margin-bottom: 75px;
  text-transform: none;
}

img::selection {
  background: 0 0;
}

img::-moz-selection {
  background: 0 0;
}

.scrolled {
  background-color: rgba(225, 225, 225, 0.8);
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.4);
}

#mainNav .navbar-toggler {
  font-size: 12px;
  right: 0;
  padding: 13px;
  text-transform: uppercase;
  color: #ffffff;
  border: 0;
  background-color: #ff9900;
  font-family: "Roboto", Verdana, sans-serif;
  margin-right: 10px;
}
#mainNav .navbar-brand {
  font-family: "Roboto", Verdana, sans-serif;
}
#mainNav .navbar-brand:active {
  color: #ff9900;
}
#mainNav .navbar-brand:focus {
  color: #ff9900;
}
#mainNav .navbar-brand:hover {
  color: #ff9900;
}
#mainNav .navbar-collapse {
  background-color: #D0CBBC;
  color: #000000;
  border-style: none;
}
#mainNav .navbar-nav .nav-item {
  text-align: right;
  padding-right: 10px;
}
#mainNav .navbar-nav .nav-item .nav-link {
  font-size: 1rem;
  padding: 0.75em 0;
  letter-spacing: 1px;
  color: #000000;
  font-family: "Roboto", Verdana, sans-serif;
}
#mainNav .navbar-nav .nav-item .nav-link:active {
  font-weight: bold;
  color: #C67700;
}
#mainNav .navbar-nav .nav-item .nav-link:focus {
  font-weight: bold;
  color: #FFB039;
}
#mainNav .navbar-nav .nav-item .nav-link:hover {
  font-weight: bold;
  color: #FFB039;
}
#mainNav .navbar-nav .nav-item .nav-link-scrolled {
  font-size: 1rem;
  padding: 0.75em 0;
  letter-spacing: 1px;
  color: #000000;
  font-family: "Roboto", Verdana, sans-serif;
}
#mainNav .navbar-nav .nav-item .nav-link-scrolled:active {
  color: #C67700;
}
#mainNav .navbar-nav .nav-item .nav-link-scrolled:focus {
  font-weight: bold;
  color: #FFB039;
}
#mainNav .navbar-nav .nav-item .nav-link-scrolled:hover {
  color: #FFB039;
}

#ezcLogo {
  max-height: 44px;
  max-width: 150px;
}

section.masthead {
  text-align: center;
  color: #000000;
  background-image: url(/welcome/images/ezc_web_image_0_Home_2.jpg);
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-position-x: 75%;
  background-size: cover;
}
section.masthead .container {
  margin-left: 2px;
}
section.masthead .intro-text {
  padding-top: 250px;
  padding-bottom: 50px;
}
section.masthead .intro-text .intro-lead-in {
  font-style: italic;
  margin-bottom: 25px;
  font-family: "Roboto", Verdana, sans-serif;
}
section.masthead .intro-text .intro-heading h4 {
  font-family: "Roboto", Verdana, sans-serif;
}

#signup {
  float: none;
  margin: 0 auto;
  padding-right: 25px;
  padding-left: 25px;
}
#signup .form-group {
  width: 80%;
  padding-left: 10px;
}
#signup .card .card-block .row.col-lg-12 {
  margin: 0;
  padding: 10px;
}

#footersignin {
  font-weight: 700;
  padding-top: 10px;
}

.horz-image-section {
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-position: center top;
  background-size: contain;
}

#horz-image-1 {
  height: 180px;
  background-image: url(/welcome/images/clock_in_out_anywhere_banner.jpg);
  background-position-x: 15%;
  background-color: #E1E1E1;
}
#horz-image-1 .horz-image-header {
  padding-top: 100px;
  padding-left: 5%;
}
#horz-image-1 .horz-image-text {
  padding-top: 2px;
  padding-left: 5%;
}

#horz-image-2 {
  height: 230px;
  margin-top: 0;
  background-image: url(/welcome/images/gps_verification_banner.jpg);
  background-position-x: 70%;
  background-color: #E1E1E1;
}
#horz-image-2 .horz-image-header {
  padding-top: 118px;
  padding-left: 5%;
}
#horz-image-2 .horz-image-text {
  padding-top: 0;
  padding-left: 5%;
}

#horz-image-3 {
  height: 220px;
  margin-top: 0;
  background-image: url(/welcome/images/online_scheduling_banner.jpg);
  background-position-x: 15%;
  background-color: #E1E1E1;
}
#horz-image-3 .horz-image-header {
  padding-top: 100px;
  padding-left: 5%;
}
#horz-image-3 .horz-image-text {
  padding-top: 0;
  padding-left: 5%;
}

#ezMarketingVideo {
  background-color: #E1E1E1;
}
#ezMarketingVideo .container {
  padding-top: 20px;
}

#video-col {
  background-color: #E1E1E1;
  padding-left: 50px;
  padding-right: 50px;
  padding-bottom: 15px;
}

#ezClockerFeatures {
  background-color: #ffffff;
}
#ezClockerFeatures .container {
  padding: 15px;
  max-width: 90%;
}
#ezClockerFeatures .options-col {
  padding-left: 3rem;
  padding-right: 3rem;
  padding-top: 10px;
  padding-bottom: 25px;
}
#ezClockerFeatures .option-text-container {
  text-align: justify;
  margin-left: 1px;
  padding-bottom: 30px;
}
#ezClockerFeatures .text-muted {
  font-size: 0.8rem;
}
#ezClockerFeatures .learn-more {
  margin-top: 10px;
  border-style: solid;
  border-width: 0.8px;
  border-color: #fec503;
  padding: 13px;
  border-radius: 25px;
}
#ezClockerFeatures .learn-more:hover {
  background-color: #ffc500;
  color: #000000;
}

.filler-helper {
  height: 100%;
  vertical-align: middle;
}

.filler-image-middle {
  height: 100%;
  width: 100%;
  text-align: center;
  vertical-align: middle;
}

#filler {
  padding: 30px;
  vertical-align: center;
  background-color: #6d6e70;
}
#filler .col-md-3 {
  vertical-align: middle;
  margin-bottom: 30px;
}
#filler .col-md-3:last-child {
  margin-bottom: 0;
}
#filler img {
  max-width: 140px;
  max-height: 40px;
}

#ezClockerFeedback {
  background-color: rgba(225, 225, 225, 0.3);
}
#ezClockerFeedback .carousel-item {
  padding-top: 15px;
  padding-bottom: 15px;
}
#ezClockerFeedback .carousel-item h6 {
  font-size: 1rem;
  font-weight: 100;
  font-style: italic;
  font-family: "Roboto", Verdana, sans-serif;
}

.carousel-indicators .active {
  background-color: #ff9900;
}
.carousel-indicators li {
  background-color: #ff9900;
}

#ezcFeedbackCarousel {
  margin-left: 2px;
  margin-right: 2px;
  background-color: #f7f4ec;
}

#feedbackItem {
  padding-top: 20px;
  padding-left: 15px;
  padding-right: 15px;
  line-height: 1.2;
  height: 250px;
}

#reviewername {
  padding-top: 10px;
}
#reviewername span {
  padding-left: 10px;
  font-size: 0.6rem;
}

.carousel-prev {
  color: #ff9900;
}

.carousel-next {
  color: #ff9900;
}

.collapse-span {
  padding-left: 5px;
}

.service-heading {
  margin: 15px 0;
}

footer {
  margin-top: 10px;
  padding: 25px 0;
  text-align: center;
}
footer span.copyright {
  font-size: 90%;
  line-height: 40px;
  text-transform: none;
  font-family: "Roboto", Verdana, sans-serif;
}
footer ul.quicklinks {
  font-size: 90%;
  line-height: 40px;
  margin-bottom: 0;
  text-transform: none;
  font-family: "Roboto", Verdana, sans-serif;
}

#contact-us,
#signupCard {
  background-color: rgba(224, 224, 224, 0.8);
}

#signupCardHeader {
  background-color: #6d6e70;
}

#signupText {
  padding-top: 5px;
}

#signupbuttonrow {
  padding-top: 10px;
}

.horz-filler {
  padding: 10px;
}

#address {
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: center;
  background-color: #6a737d;
  color: #ffffff;
  font-size: 12pt;
}

#ezcFooter {
  background-color: #6a737d;
  color: #ffffff;
  padding-top: 30px;
}
#ezcFooter .footer-copyright {
  background-color: #515255;
  padding-top: 3px;
  padding-bottom: 3px;
  text-align: center;
}
#ezcFooter .footer-copyright p {
  margin: 10px;
  color: #B7BABE;
  font-size: 10pt;
}
#ezcFooter .row {
  margin-bottom: 60px;
}
#ezcFooter .navbar-brand {
  margin-top: 45px;
  height: 65px;
}
#ezcFooter ul {
  list-style-type: none;
  padding-left: 0;
  line-height: 1.7;
}
#ezcFooter h5 {
  font-size: 18px;
  color: #ffffff;
  font-weight: bold;
  margin-top: 30px;
}
#ezcFooter a {
  color: #e0e0e0;
  text-decoration: none;
}
#ezcFooter a:hover {
  color: #ffffff;
}
#ezcFooter a:focus {
  color: #ffffff;
}
#ezcFooter .social-networks {
  text-align: center;
  padding-top: 30px;
  padding-bottom: 16px;
}
#ezcFooter .social-networks a {
  font-size: 32px;
  color: #E1E1E1;
  padding: 10px;
  transition: 0.2s;
  text-decoration: none;
}
#ezcFooter .social-networks a:hover {
  color: #ffffff;
}
#ezcFooter .social-networks a:focus {
  color: #ffffff;
}

#about-collapse[aria-expanded=false] .fa-chevron-up {
  display: none;
}

#about-collapse[aria-expanded=true] .fa-chevron-down {
  display: none;
}

#indus-collapse[aria-expanded=false] .fa-chevron-up {
  display: none;
}

#indus-collapse[aria-expanded=true] .fa-chevron-down {
  display: none;
}

#product-collapse[aria-expanded=false] .fa-chevron-up {
  display: none;
}

#product-collapse[aria-expanded=true] .fa-chevron-down {
  display: none;
}

ul.social-buttons {
  margin-bottom: 0;
}
ul.social-buttons li a {
  display: block;
  width: 40px;
  height: 40px;
  transition: all 0.3s;
  color: #ffffff;
  border-radius: 100%;
  outline: 0;
  background-color: #e0e0e0;
}
ul.social-buttons li a:active {
  background-color: #ffffff;
}
ul.social-buttons li a:focus {
  background-color: #ffffff;
}
ul.social-buttons li a:hover {
  background-color: #ffffff;
}
ul.social-buttons .btn {
  color: #ffffff;
  background-color: #ff9900;
  border-radius: 20px;
  border: none;
  width: 150px;
  display: block;
  margin: 0 auto;
  margin-top: 10px;
}
ul.social-buttons h2 a {
  font-size: 50px;
  text-align: center;
  color: #ffffff;
}
ul.social-buttons .facebook:hover {
  color: #ffffff;
}
ul.social-buttons .google:hover {
  color: #ffffff;
}
ul.social-buttons .twitter:hover {
  color: #ffffff;
}

@media (min-width: 320px) {
  section.masthead {
    text-align: center;
    color: #ffffff;
    background-image: url(/welcome/images/ezc_web_image_0_Home_2.jpg);
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-position-x: 75%;
    background-size: cover;
  }
  section.masthead .container {
    margin-left: 2px;
  }
  section.masthead .intro-text {
    padding-top: 250px;
    padding-bottom: 50px;
  }
  section.masthead .intro-text .intro-lead-in {
    font-style: italic;
    margin-bottom: 25px;
    font-family: "Roboto", Verdana, sans-serif;
  }
  section.masthead .intro-text .intro-heading h4 {
    font-family: "Roboto", Verdana, sans-serif;
  }
}
@media (min-width: 576px) {
  section.masthead {
    text-align: center;
    color: #ffffff;
    background-image: url(/welcome/images/ezc_web_image_0_Home_2.jpg);
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-position-x: 75%;
    background-size: cover;
  }
  section.masthead .container {
    margin-left: 2px;
  }
  section.masthead .intro-text {
    padding-top: 250px;
    padding-bottom: 50px;
  }
  section.masthead .intro-text .intro-lead-in {
    font-style: italic;
    margin-bottom: 25px;
    font-family: "Roboto", Verdana, sans-serif;
  }
  section.masthead .intro-text .intro-heading h4 {
    font-family: "Roboto", Verdana, sans-serif;
  }
  .navbar-collapse {
    background-color: #D0CBBC;
    color: #000000;
    border-style: solid;
    border-color: #6d6e70;
    border-width: 1px;
    border-radius: 4px;
  }
  #ezcFooter .collapse-link {
    display: none;
  }
  #ezcFooter .collapse {
    display: block;
  }
}
@media (min-width: 768px) {
  section.masthead {
    text-align: center;
    color: #ffffff;
    background-image: url(/welcome/images/ezc_web_image_0_Home_2.jpg);
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-position-x: 75%;
    background-size: cover;
  }
  section.masthead .container {
    margin-left: 2px;
  }
  section.masthead .intro-text {
    padding-top: 250px;
    padding-bottom: 50px;
  }
  section.masthead .intro-text .intro-lead-in {
    font-style: italic;
    margin-bottom: 25px;
    font-family: "Roboto", Verdana, sans-serif;
  }
  section.masthead .intro-text .intro-heading h4 {
    font-family: "Roboto", Verdana, sans-serif;
  }
  #ezcLogo {
    max-height: 44px;
    max-width: 200px;
  }
  section {
    padding: 5% 0;
  }
  section h2.section-heading {
    font-size: 2rem;
    margin-top: 0;
    padding-bottom: 50px;
  }
  #signup {
    margin-left: 25px;
    padding-left: 5px;
    padding-right: 5px;
  }
  #signup h4 {
    font-size: 1.3rem;
  }
  #horz-image-1 {
    height: 230px;
    background-image: url(/welcome/images/clock_in_out_anywhere_banner.jpg);
    background-position-x: 15%;
    background-color: #E1E1E1;
    background-size: cover;
    padding-top: 150px;
    padding-bottom: 150px;
  }
  #horz-image-1 .horz-image-header {
    padding-top: 0;
    padding-left: 50%;
  }
  #horz-image-1 .horz-image-text {
    padding-top: 5px;
    padding-left: 50%;
  }
  #horz-image-2 {
    height: 230px;
    background-image: url(/welcome/images/gps_verification_banner.jpg);
    background-position: 70%;
    background-color: #E1E1E1;
    background-size: cover;
    padding-top: 150px;
    padding-bottom: 150px;
  }
  #horz-image-2 .horz-image-header {
    padding-top: 0;
    padding-left: 2%;
    padding-right: 60%;
  }
  #horz-image-2 .horz-image-text {
    padding-top: 5px;
    padding-left: 2%;
    padding-right: 50%;
  }
  #horz-image-3 {
    height: 230px;
    background-image: url(/welcome/images/online_scheduling_banner.jpg);
    background-position-x: 15%;
    background-color: #E1E1E1;
    background-size: cover;
    padding-top: 150px;
    padding-bottom: 150px;
  }
  #horz-image-3 .horz-image-header {
    padding-top: 0;
    padding-left: 50%;
  }
  #horz-image-3 .horz-image-text {
    padding-top: 5px;
    padding-left: 50%;
  }
  #video-col {
    padding-left: 150px;
    padding-right: 150px;
  }
  #feedbackItem {
    padding-top: 50px;
    padding-left: 50px;
    padding-right: 50px;
    line-height: 1.2;
    height: 250px;
  }
  #reviewername span {
    font-size: 0.8rem;
  }
  #filler .col-md-3 {
    margin-bottom: 0;
  }
  #video .container {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  #ezClockerFeatures .container {
    padding-top: 0;
  }
  #ezClockerFeatures .text-muted {
    font-size: 1rem;
  }
  #ezClockerFeedback .carousel-item h6 {
    font-size: 1.2rem;
  }
  .navbar-collapse {
    background-color: #D0CBBC;
    color: #000000;
    border-style: solid;
    border-color: #6d6e70;
    border-width: 1px;
    border-radius: 4px;
  }
}
@media screen and (max-width: 767px) {
  #ezcFooter {
    text-align: center;
  }
}
@media screen and (min-width: 992px) {
  #ezcFeedbackCarousel {
    margin-left: 150px;
    margin-right: 150px;
    background-color: #f7f4ec;
  }
  #mainNav .container {
    margin-left: 15px;
    max-width: 100%;
  }
  #mainNav .navbar-nav .nav-item {
    color: #ffffff;
  }
  #mainNav .navbar-nav .nav-item .nav-link-scrolled {
    font-size: 1rem;
    padding: 0.75em 0;
    letter-spacing: 1px;
    color: #000000;
    font-family: "Roboto", Verdana, sans-serif;
  }
  #mainNav .navbar-nav .nav-item .nav-link-scrolled.active {
    color: #C67700;
  }
  #mainNav .navbar-nav .nav-item .nav-link-scrolled:hover {
    color: #FFB039;
  }
  #mainNav .navbar-collapse {
    background-color: transparent;
  }
  section.masthead {
    background-position: right top;
    padding-bottom: 10px;
  }
  section.masthead .intro-text {
    padding-top: 40px;
    padding-bottom: 25px;
    text-align: left;
  }
  section.masthead .intro-text .intro-heading {
    margin-bottom: 40px;
    font-family: "Roboto", Verdana, sans-serif;
    color: #000000;
  }
  section.masthead .intro-text .intro-heading .title-margin {
    margin-left: 15px;
  }
  section.masthead .intro-text .intro-lead-in {
    font-size: 40px;
    font-style: italic;
    line-height: 40px;
    margin-bottom: 25px;
    font-family: "Roboto", Verdana, sans-serif;
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
/*------------------------------------------------------
| @Media Small Mobile Devices
--------------------------------------------------------*/
/*------------------------------------------------------
| @Media for Regular Mobile Devices
--------------------------------------------------------*/
/*------------------------------------------------------
| @Media for Tablets
--------------------------------------------------------*/
/*------------------------------------------------------
| @Media for Laptops
--------------------------------------------------------*/
/*------------------------------------------------------
| @Media for Desktops
--------------------------------------------------------*/
@media only screen and (min-width: 1920px) {
  .navbar-collapse {
    background-color: transparent;
    color: #000000;
    border-style: none;
  }
}`, "",{"version":3,"sources":["webpack://./ezlibrary/welcome/css/ez-responsive.scss","webpack://./ezlibrary/welcome/css/ez-core.scss","webpack://./ezlibrary/welcome/css/index.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;CAAA;AAyDA;;yDAAA;AAaA;;yDAAA;AAOA;;yDAAA;AAQA;;yDAAA;AAQA;;yDAAA;AAQA;;yDAAA;ACnGA,gDAAA;AA0LA;EACI,gTAAA;EAIA,uCAAA;AC5JJ;;AD+JA;EACI,WAAA;AC5JJ;;AD+JA;EACI,WAAA;AC5JJ;;AD+JA;EACI,aAAA;AC5JJ;;AD+JA;EACI,aAAA;AC5JJ;;AD+JA;EACI,eAAA;AC5JJ;;AD+JA;EACI,WAAA;AC5JJ;;AAVA;EACI,aAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,2DAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,0BAAA;EACA,4BAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAaJ;;AAVA;EACI,YAAA;AAaJ;;AAVA;EACI,SAAA;EACA,UAAA;AAaJ;;AATA;EACI,0CDyCqB;AC7BzB;AAXI;EACI,mBFhEmB;EEiEnB,gBAAA;EACA,mBAAA;EACA,cD9ES;AC2FjB;AAXI;EACI,cDxFQ;ECyFR,mBFvEmB;EEwEnB,mBAAA;EACA,oBAAA;AAaR;;AATA;EACI,eAAA;AAYJ;;AATA;EACI,eAAA;AAYJ;;AATA;EACI,0CDkByB;ECjBzB,0CAAA;AAYJ;;AARI;EACI,eAAA;EACA,QAAA;EACA,aAAA;EACA,yBAAA;EACA,cD1GS;EC2GT,SAAA;EACA,yBDrHU;ECsHV,0CAAA;EACA,kBAAA;AAWR;AATI;EACI,0CAAA;AAWR;AAVQ;EACI,cD5HM;ACwIlB;AAVQ;EACI,cD/HM;AC2IlB;AAVQ;EACI,cDlIM;AC8IlB;AATI;EACI,yBD9GY;EC+GZ,cD/HS;ECgIT,kBAAA;AAWR;AATI;EACI,iBAAA;EACA,mBAAA;AAWR;AAVQ;EACI,eF/HiB;EEgIjB,iBAAA;EACA,mBAAA;EACA,cDzIK;EC0IL,0CAAA;AAYZ;AAXY;EACI,iBAAA;EACA,cDtHD;ACmIf;AAXY;EACI,iBAAA;EACA,cD3HA;ACwIhB;AAXY;EACI,iBAAA;EACA,cD/HA;AC4IhB;AAVQ;EACI,eFlJiB;EEmJjB,iBAAA;EACA,mBAAA;EACA,cD5JK;EC6JL,0CAAA;AAYZ;AAXY;EACI,cDxID;ACqJf;AAXY;EACI,iBAAA;EACA,cD7IA;AC0JhB;AAXY;EACI,cDhJA;AC6JhB;;AAPA;EACI,gBAAA;EACA,gBAAA;AAUJ;;AAPA;EACI,kBAAA;EACA,cDnLa;ECoLb,iEAnJI;EAoJJ,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,sBAAA;AAUJ;AATI;EACI,gBAAA;AAWR;AATI;EACI,kBAAA;EACA,oBAAA;AAWR;AAVQ;EACI,kBAAA;EACA,mBAAA;EACA,0CAAA;AAYZ;AAVQ;EACI,0CAAA;AAYZ;;AAPA;EACI,WAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAUJ;AATI;EACI,UAAA;EACA,kBAAA;AAWR;AATI;EACI,SAAA;EACA,aAAA;AAWR;;AAPA;EACI,gBAAA;EACA,iBAAA;AAUJ;;AAPA;EACI,4BAAA;EACA,6BAAA;EACA,+BAAA;EACA,wBAAA;AAUJ;;AAPA;EACI,aAAA;EACA,uEArMI;EAsMJ,0BAAA;EACA,yBDpOkB;AC8OtB;AATI;EACI,kBAAA;EACA,gBAAA;AAWR;AATI;EACI,gBAAA;EACA,gBAAA;AAWR;;AAPA;EACI,aAAA;EACA,aAAA;EACA,kEApNI;EAqNJ,0BAAA;EACA,yBDpPkB;AC8PtB;AATI;EACI,kBAAA;EACA,gBAAA;AAWR;AATI;EACI,cAAA;EACA,gBAAA;AAWR;;AAPA;EACI,aAAA;EACA,aAAA;EACA,mEAnOI;EAoOJ,0BAAA;EACA,yBDpQkB;AC8QtB;AATI;EACI,kBAAA;EACA,gBAAA;AAWR;AATI;EACI,cAAA;EACA,gBAAA;AAWR;;AAPA;EACI,yBDhRkB;AC0RtB;AATI;EACI,iBAAA;AAWR;;AAPA;EACI,yBDvRkB;ECwRlB,kBAAA;EACA,mBAAA;EACA,oBAAA;AAUJ;;AAPA;EACI,yBDlSa;AC4SjB;AATI;EACI,aAAA;EACA,cAAA;AAWR;AATI;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AAWR;AATI;EACI,mBAAA;EACA,gBAAA;EACA,oBAAA;AAWR;AATI;EACI,iBAAA;AAWR;AATI;EACI,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AAWR;AATI;EACI,yBDrUU;ECsUV,cDhUS;AC2UjB;;AAPA;EACI,YAAA;EACA,sBAAA;AAUJ;;AARA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AAWJ;;AARA;EACI,aAAA;EACA,sBAAA;EACA,yBDvVY;ACkWhB;AAVI;EACI,sBAAA;EACA,mBAAA;AAYR;AAXQ;EACI,gBAAA;AAaZ;AAVI;EACI,gBAAA;EACA,gBAAA;AAYR;;AARA;EACI,0CD/OqB;AC0PzB;AAVI;EACI,iBAAA;EACA,oBAAA;AAYR;AAXQ;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;AAaZ;;AAPI;EACI,yBDxXU;ACkYlB;AARI;EACI,yBD3XU;ACqYlB;;AANA;EACI,gBAAA;EACA,iBAAA;EACA,yBDtXmB;AC+XvB;;AANA;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AASJ;;AANA;EACI,iBAAA;AASJ;AARI;EACI,kBAAA;EACA,iBAAA;AAUR;;AANA;EACI,cDtZc;AC+ZlB;;AANA;EACI,cD1Zc;ACmalB;;AANA;EACI,iBAAA;AASJ;;AANA;EACI,cAAA;AASJ;;AANA;EACI,gBAAA;EACA,eAAA;EACA,kBAAA;AASJ;AARI;EACI,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,0CAAA;AAUR;AARI;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,0CAAA;AAUR;;AANA;;EAEI,0CDxWY;ACiXhB;;AANA;EACI,yBD3bY;ACochB;;AANA;EACI,gBAAA;AASJ;;AALA;EACI,iBAAA;AAQJ;;AALA;EACI,aAAA;AAQJ;;AALA;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBD9cgB;EC+chB,cD1ca;EC2cb,eAAA;AAQJ;;AALA;EACI,yBDpdgB;ECqdhB,cDhda;ECidb,iBAAA;AAQJ;AAPI;EACI,yBD7ZK;EC8ZL,gBAAA;EACA,mBAAA;EACA,kBAAA;AASR;AARQ;EACI,YAAA;EACA,cD7ZM;EC8ZN,eAAA;AAUZ;AAPI;EACI,mBAAA;AASR;AAPI;EACI,gBAAA;EACA,YAAA;AASR;AAPI;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;AASR;AAPI;EACI,eAAA;EACA,cD3eS;EC4eT,iBAAA;EACA,gBAAA;AASR;AAPI;EACI,cDpfU;ECqfV,qBAAA;AASR;AARQ;EACI,cDnfK;AC6fjB;AARQ;EACI,cDtfK;ACggBjB;AAPI;EACI,kBAAA;EACA,iBAAA;EACA,oBAAA;AASR;AARQ;EACI,eAAA;EACA,cD3fU;EC4fV,aAAA;EACA,gBAAA;EACA,qBAAA;AAUZ;AATY;EACI,cDpgBC;AC+gBjB;AATY;EACI,cDvgBC;ACkhBjB;;AAJA;EACI,aAAA;AAOJ;;AAJA;EACI,aAAA;AAOJ;;AAJA;EACI,aAAA;AAOJ;;AAJA;EACI,aAAA;AAOJ;;AAJA;EACI,aAAA;AAOJ;;AAJA;EACI,aAAA;AAOJ;;AAJA;EACI,gBAAA;AAOJ;AANI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,cD7iBS;EC8iBT,mBAAA;EACA,UAAA;EACA,yBDpjBU;AC4jBlB;AAPQ;EACI,yBDljBK;AC2jBjB;AAPQ;EACI,yBDrjBK;AC8jBjB;AAPQ;EACI,yBDxjBK;ACikBjB;AANI;EACI,cD5jBS;EC6jBT,yBDtkBU;ECukBV,mBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AAQR;AANI;EACI,eAAA;EACA,kBAAA;EACA,cDxkBS;ACglBjB;AANI;EACI,cD3kBS;ACmlBjB;AANI;EACI,cD9kBS;ACslBjB;AANI;EACI,cDjlBS;ACylBjB;;AAJA;EACI;IACI,kBAAA;IACA,cDxlBS;ICylBT,iEAzjBA;IA0jBA,4BAAA;IACA,6BAAA;IACA,0BAAA;IACA,sBAAA;EAON;EANM;IACI,gBAAA;EAQV;EANM;IACI,kBAAA;IACA,oBAAA;EAQV;EAPU;IACI,kBAAA;IACA,mBAAA;IACA,0CAAA;EASd;EAPU;IACI,0CAAA;EASd;AACF;AAJA;EACI;IACI,kBAAA;IACA,cDnnBS;IConBT,iEAplBA;IAqlBA,4BAAA;IACA,6BAAA;IACA,0BAAA;IACA,sBAAA;EAMN;EALM;IACI,gBAAA;EAOV;EALM;IACI,kBAAA;IACA,oBAAA;EAOV;EANU;IACI,kBAAA;IACA,mBAAA;IACA,0CAAA;EAQd;EANU;IACI,0CAAA;EAQd;EAJE;IACI,yBD3nBY;IC4nBZ,cD5oBS;IC6oBT,mBAAA;IACA,qBDnpBQ;ICopBR,iBAAA;IACA,kBAAA;EAMN;EAHM;IACI,aAAA;EAKV;EAHM;IACI,cAAA;EAKV;AACF;AADA;EACI;IACI,kBAAA;IACA,cD9pBS;IC+pBT,iEA/nBA;IAgoBA,4BAAA;IACA,6BAAA;IACA,0BAAA;IACA,sBAAA;EAGN;EAFM;IACI,gBAAA;EAIV;EAFM;IACI,kBAAA;IACA,oBAAA;EAIV;EAHU;IACI,kBAAA;IACA,mBAAA;IACA,0CAAA;EAKd;EAHU;IACI,0CAAA;EAKd;EADE;IACI,gBAAA;IACA,gBAAA;EAGN;EADE;IACI,aAAA;EAGN;EAFM;IACI,eAAA;IACA,aAAA;IACA,oBAAA;EAIV;EADE;IACI,iBAAA;IACA,iBAAA;IACA,kBAAA;EAGN;EAFM;IACI,iBAAA;EAIV;EADE;IACI,aAAA;IACA,uEAzqBA;IA0qBA,0BAAA;IACA,yBDxsBc;ICysBd,sBAAA;IACA,kBAAA;IACA,qBAAA;EAGN;EAFM;IACI,cAAA;IACA,iBAAA;EAIV;EAFM;IACI,gBAAA;IACA,iBAAA;EAIV;EADE;IACI,aAAA;IACA,kEAzrBA;IA0rBA,wBAAA;IACA,yBDztBc;IC0tBd,sBAAA;IACA,kBAAA;IACA,qBAAA;EAGN;EAFM;IACI,cAAA;IACA,gBAAA;IACA,kBAAA;EAIV;EAFM;IACI,gBAAA;IACA,gBAAA;IACA,kBAAA;EAIV;EADE;IACI,aAAA;IACA,mEA3sBA;IA4sBA,0BAAA;IACA,yBD5uBc;IC6uBd,sBAAA;IACA,kBAAA;IACA,qBAAA;EAGN;EAFM;IACI,cAAA;IACA,iBAAA;EAIV;EAFM;IACI,gBAAA;IACA,iBAAA;EAIV;EADE;IACI,mBAAA;IACA,oBAAA;EAGN;EADE;IACI,iBAAA;IACA,kBAAA;IACA,mBAAA;IACA,gBAAA;IACA,aAAA;EAGN;EAAM;IACI,iBAAA;EAEV;EACE;IACI,gBAAA;EACN;EACE;IACI,gBAAA;IACA,mBAAA;EACN;EAEM;IACI,cAAA;EAAV;EAEM;IACI,eAAA;EAAV;EAGE;IACI,iBAAA;EADN;EAIE;IACI,yBDlxBY;ICmxBZ,cDnyBS;ICoyBT,mBAAA;IACA,qBD1yBQ;IC2yBR,iBAAA;IACA,kBAAA;EAFN;AACF;AAKA;EACI;IACI,kBAAA;EAHN;AACF;AAOA;EACI;IACI,kBAAA;IACA,mBAAA;IACA,yBDlzBe;EC6yBrB;EAOE;IACI,iBAAA;IACA,eAAA;EALN;EAOE;IACI,cD5zBS;ECuzBf;EAOE;IACI,eFzzBqB;IE0zBrB,iBAAA;IACA,mBAAA;IACA,cDn0BS;ICo0BT,0CAAA;EALN;EAMM;IACI,cD/yBG;EC2yBb;EAMM;IACI,cDnzBI;EC+yBd;EAOE;IACI,6BAAA;EALN;EAOE;IACI,8BAAA;IACA,oBAAA;EALN;EAMM;IACI,iBAAA;IACA,oBAAA;IACA,gBAAA;EAJV;EAKU;IAII,mBAAA;IACA,0CAAA;IACA,cD51BC;ECs1Bf;EAOc;IACI,iBAAA;EALlB;EAQU;IACI,eAAA;IACA,kBAAA;IACA,iBAAA;IACA,mBAAA;IACA,0CAAA;EANd;AACF;AAWA;EACI;IACI,iBAAA;EATN;AACF;AAaA;;yDAAA;AAOA;;yDAAA;AAQA;;yDAAA;AAQA;;yDAAA;AAQA;;yDAAA;AAGA;EAEQ;IACA,6BAAA;IACA,cDz5BS;IC05BT,kBAAA;EA/BN;AACF","sourcesContent":["/*\r\nDefault Font Size is 14px on the HTML page, use the below scale to adjust font sizes.\r\n\r\n8pt = 0.571rem\r\n10pt = 0.714rem\r\n12pt = 0.857rem\r\n14pt = 1rem (base font size)\r\n18pt = 1.285rem\r\n20pt = 1.428rem\r\n22pt = 1.571rem\r\n24pt = 1.714rem\r\n28pt = 2rem\r\n30pt = 2.142rem\r\n32pt = 2.285rem\r\n*/\r\n\r\n// Responseive Font Sizes\r\n$ezResponsivePicoFontSize: 0.517rem;\r\n$ezResponsiveMicroFontSize: 0.714rem;\r\n$ezResponsiveSmallFontSize: 0.857rem;\r\n$ezResponsiveNormalFontSize: 1rem;\r\n$ezResponsiveMediumFontSize: 1.285rem;\r\n$ezResponsiveLargeFontSize: 1.428rem;\r\n$ezResponsiveExtraLargeFontSize: 1.571rem;\r\n$ezResponsiveHugeFontSize: 1.714rem;\r\n$ezResponsiveExtraHugeFontSize: 2rem;\r\n$ezResponsiveMassiveFontSize: 2.142rem;\r\n$ezResponsiveExtraMassiveFontSize: 2.285rem;\r\n\r\n// Responseive Font Sizes\r\n$ezResponsiveMarketingPicoFontSize: $ezResponsiveMicroFontSize;\r\n$ezResponsiveMarketingMicroFontSize: $ezResponsiveSmallFontSize;\r\n$ezResponsiveMarketingSmallFontSize: $ezResponsiveNormalFontSize;\r\n$ezResponsiveMarketingNormalFontSize: $ezResponsiveMediumFontSize;\r\n$ezResponsiveMarketingMediumFontSize: $ezResponsiveLargeFontSize;\r\n$ezResponsiveMarketingLargeFontSize: $ezResponsiveExtraLargeFontSize;\r\n$ezResponsiveMarketingExtraLargeFontSize: $ezResponsiveHugeFontSize;\r\n$ezResponsiveMarketingHugeFontSize: $ezResponsiveExtraHugeFontSize;\r\n$ezResponsiveMarketingExtraHugeFontSize: $ezResponsiveMassiveFontSize;\r\n$ezResponsiveMarketingMassiveFontSize: $ezResponsiveExtraMassiveFontSize;\r\n$ezResponsiveMarketingSuperFontSize: 2.428rem;\r\n\r\n// Responsive Normal Header and Title Font Sizes\r\n$ezResponsiveHeaderFontSize: $ezResponsiveExtraLargeFontSize;\r\n$ezResponsiveSubHeaderFontSize: $ezResponsiveMediumFontSize;\r\n$ezResponsiveTitleFontSize: $ezResponsiveLargeFontSize;\r\n$ezResponsiveLabelFontSize: $ezResponsiveMediumFontSize;\r\n\r\n// Responsive Marketing Header and Title Font Sizes\r\n$ezResponsiveMarketingHeaderFontSize: $ezResponsiveHugeFontSize;\r\n$ezResponsiveMarketingSubHeaderFontSize: $ezResponsiveHugeFontSize;\r\n$ezResponsiveMarketingTitleFontSize: $ezResponsiveHugeFontSize;\r\n\r\n$ezRespnsiveLogoWidth: 100%;\r\n$ezResponseLogoHeight: auto;\r\n\r\n\r\n/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| ezClocker Supported Media Screen Sizes\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/\r\n$ezSmallMobileMinWidth: 240;\r\n$ezSmallMobileMaxWidth: 319;\r\n$ezMobileMinWidth: 320px;\r\n$ezMobileMaxWidth: 480px;\r\n$ezTabletMinWidth: 481px;\r\n$ezTabletMaxWidth: 1023px;\r\n$ezLaptopMinWidth: 1024px;\r\n$ezLaptopMaxWidth: 1919px;\r\n$ezDesktopMinWidth: 1920px;\r\n\r\n/*------------------------------------------------------\r\n| @Media Small Mobile Devices\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (max-width: $ezSmallMobileMaxWidth)  {\r\n}\r\n\r\n/*------------------------------------------------------\r\n| @Media for Regular Mobile Devices\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (min-width: $ezMobileMinWidth) and\r\n    (max-width: $ezMobileMaxWidth)  {\r\n}\r\n\r\n/*------------------------------------------------------\r\n| @Media for Tablets\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (min-width: $ezTabletMinWidth) and\r\n    (max-width: $ezTabletMaxWidth) {\r\n}\r\n\r\n/*------------------------------------------------------\r\n| @Media for Laptops\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (min-width: $ezLaptopMinWidth) and\r\n    (max-width: $ezLaptopMaxWidth) {\r\n}\r\n\r\n/*------------------------------------------------------\r\n| @Media for Desktops\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (min-width: $ezDesktopMinWidth) {\r\n}\r\n\r\n","@use 'ez-responsive.scss';\r\n\r\n/* Use http://paletton.com to generate pallets */\r\n\r\n// Primary ezClocker Colors\r\n$ezClockerOrange: #ff9900;\r\n$ezClockerNavy: #0f4777; // rgb(15,71,119)\r\n$ezClockerYellow: #ffc500;\r\n$ezClockerGray: #6d6e70; // rgb(109,110,112)\r\n$ezClockerAquaGray: #6a737d;\r\n$ezClockerSilver: #e0e0e0; // rgb(224,224,224)\r\n$ezClockerActionGreen: #8EF13C;\r\n$ezClockerAlertRed: #FF0700;\r\n$ezClockerBlack: #000000;\r\n$ezClockerWhite: #ffffff;\r\n\r\n// Specail Use Colors\r\n$ezClockerSmokeyTooth: #f7f4ec;\r\n$ezClockerBackground: #E1E1E1;\r\n\r\n// Rarely Used Legacy Colors\r\n$ezClockerAqua: #316dac;\r\n$ezClockerBlue: #2419b2;\r\n$ezClockerBabyBlue: #7CD0FD;\r\n\r\n// ezClocker Smokey Tooth Shades (#f7f4ec)\r\n$ezSmokeyTooth: $ezClockerSmokeyTooth;\r\n$ezSmokeyToothLight: $ezClockerWhite;\r\n$ezSmokeyToothHover: #FFFEFC;\r\n$ezDarkSmokeyTooth: #D0CBBC;\r\n$ezBorderSmokeyTooth: #AFA68E;\r\n\r\n// ezClocker Orange Shades (#ff9900)\r\n$ezOrange: #ff9900;\r\n$ezLightOrange: #FFC164;\r\n$ezHoverOrange: #FFB039;\r\n$ezDarkOrange: #C67700;\r\n$ezBorderOrange: #9B5D00;\r\n\r\n// ezClocker Navy Shades (#0f4777)\r\n$ezNavy: var($ezClockerNavy);\r\n$ezNavyContainerTextColor: var($ezClockerWhite);\r\n$ezLightNavy: #3B6F9B;\r\n$ezHoverNavy: #1D5D93;\r\n$ezDarkNavy: #063861;\r\n$ezBorderNavy: #032746;\r\n$ezAqua: var($ezClockerAqua);\r\n$ezLightAqua: #7AA7D5;\r\n$ezHoverAqua: #4F85BE;\r\n$ezDarkAqua: #1058A3;\r\n$ezBorderAqua: #0A417A;\r\n$ezNavyContainerDisabledTextColor: var($ezBorderNavy);\r\n$ezNavyAlpha: rgba(15, 71, 119, 0.8);\r\n\r\n// ezClocker yellow shades (#ffc500)\r\n$ezYellow: var($ezClockerYellow);\r\n$ezYelloContainerText: #000000;\r\n$ezLightYellow: #FFDB64;\r\n$ezHoverYellow: #FFD239;\r\n$ezDarkYellow: #C69800;\r\n$ezBorderYellow: #9B7800;\r\n\r\n// ezClocker Gray shades (#6d6e70)\r\n$ezGrayAlpha: rgba(109, 110, 112, 0.9);\r\n$ezGray: $ezClockerGray;\r\n$ezGrayContainerText: $ezClockerWhite;\r\n$ezLightGray: #B2B3B4;\r\n$ezHoverGray: #8A8B8D;\r\n$ezDarkGray: #515255;\r\n$ezBorderGray: #323437;\r\n\r\n// ezClocker Aqua Gray Shared\r\n$ezAquaGray: $ezClockerGray;\r\n$ezAquaGrayContainerText: $ezClockerBackground;\r\n$ezLightAquaGray: #B7BABE;\r\n$ezHoverAquaGray: #898F96;\r\n$ezDarkAquaGray: #505B67;\r\n$ezBorderAquaGray: #374350;\r\n\r\n// ezClocker Blue Shades (#2419b2)\r\n$ezBlue: var($ezClockerGray);\r\n$ezLightBlue: #665EC6;\r\n$ezHoverBlue: #463DB7;\r\n$ezDarkBlue: #1B128A;\r\n$ezBorderBlue: #120B6D;\r\n\r\n// ezClocker silver shares (#e0e0e0)\r\n$ezSilverAlpha: rgba(224, 224, 224, 0.8);\r\n$ezSilver: var($ezClockerSilver);\r\n$ezLightSilver: #f0f0f0;\r\n$ezDarkSilver: #B3B3B3;\r\n$ezBorderSilver: #878686;\r\n\r\n// ezClocker ActionGreen shaes (#8EF13C)\r\n$ezActionGreen: var($ezClockerActionGreen);\r\n$ezLightActionGreen: #C0F991;\r\n$ezHoverActionGreen: #A5F562;\r\n$ezDarkGreen: #77ED16;\r\n$ezBorderGreen: #65DF00;\r\n\r\n// ezClocker AlertRed shades (#FF0700)\r\n$ezAlertText: var($ezClockerWhite);\r\n$ezAlertRed: var($ezClockerAlertRed);\r\n$ezLightAlertRed: #FF6864;\r\n$ezHoverAlertRed: #FF3E39;\r\n$ezDarkAlertRed: #C60500;\r\n$ezBorderAlertRed: #9B0400;\r\n\r\n// ezClocker BabyBlue (#7CD0FD) Shades\r\n$ezBabyBlue: var($ezClockerBabyBlue);\r\n$ezLightBabyBlue: #E8F7FF;\r\n$ezHoverBabyBlue: #A9E0FE;\r\n$ezDarkBabyBlue: #54C0FA;\r\n$ezBorderBabyBlue: #2CACF1;\r\n\r\n// Black Shades\r\n$ezBlack: #000000;\r\n$ezLightBlack: #7F7E7E;\r\n$ezHoverBlack: #464646;\r\n\r\n// White Shades\r\n$ezWhite: var($ezClockerWhite);\r\n$ezDarkWhite: #CECECE;\r\n$ezBorderWhite: #A2A0A0;\r\n\r\n// Background Colors\r\n$ezBackgroundColor: $ezClockerBackground;\r\n$ezAlphaBackgroundColor: rgba(225, 225, 225, .3);\r\n$ezAlphaDarkBackgroundColor: rgba(225, 225, 225, .8);\r\n$ezGrayAlphaBackgroundColor: rgba(128, 128, 128, .4);\r\n$ezDarkBackgroundColor: #B4B4B4;\r\n$ezDarkAlphaBackgroundColor: rgba(180, 180, 180, .3);\r\n\r\n$ezBorderBackgrounColor: #888787;\r\n$ezBorderAlphaBackgroundColor: rgba(136, 135, 135, .3);\r\n\r\n$ezBackgroundImageGradientAlphaWhite1: rgba(255, 255, 255, .07);\r\n$ezBackgroundImageGradientAlphaWhite2: rgba(255, 255, 255, .13);\r\n$ezBackgroundImageGradientAlphaWhite3: rgba(255, 255, 255, .17);\r\n$ezBackgroundImageGradientAlphaWhite4: rgba(255, 255, 255, .19);\r\n\r\n// Text Colors\r\n$ezTextColor: $ezClockerBlack;\r\n$ezLightTextColor: $ezClockerGray;\r\n$ezTitleTextColor: $ezClockerNavy;\r\n$ezHeaderTextColor: $ezClockerBlack;\r\n$ezSubHeaderTextColor: $ezClockerNavy;\r\n\r\n// Font Family\r\n$ezFontFamilyRoboto: 'Roboto';\r\n$ezFontFamilyVerdana: Verdana;\r\n$ezFontFamilySansSerif: sans-serif;\r\n\r\n// Normal Font Sizes\r\n$ezFontSize: 14pt;\r\n\r\n$ezPicoFontSize: 8pt;\r\n$ezMicroFontSize: 10pt;\r\n$ezSmallFontSize: 12pt;\r\n$ezNormalFontSize: $ezFontSize;\r\n$ezMediumFontSize: 18pt;\r\n$ezLargeFontSize: 20pt;\r\n$ezExtraLargeFontSize: 22pt;\r\n\r\n// Normal Header and Title Font Sizes\r\n$ezHeaderFontSize: $ezExtraLargeFontSize;\r\n$ezSubHeaderFontSize: $ezMediumFontSize;\r\n$ezTitleFontSize: $ezLargeFontSize;\r\n\r\n// Marketing Font Sizes\r\n$ezMarketingPicoFontSize: $ezMicroFontSize;\r\n$ezMarketingMicroFontSize: $ezSmallFontSize;\r\n$ezMarketingSmallFontSize: $ezNormalFontSize;\r\n$ezMarketingNormalFontSize: $ezMediumFontSize;\r\n$ezMarketingMediumFontSize: $ezLargeFontSize;\r\n$esMarketingLargeFontSize: $ezExtraLargeFontSize;\r\n$ezMarketingExtraLargeFontSize: 24pt;\r\n\r\n// Marketing Header and Title Font Sizes\r\n$ezMarketingHeaderFontSize: $ezMarketingExtraLargeFontSize;\r\n$ezMarketingSubHeaderFontSize: $ezMarketingMediumFontSize;\r\n$ezMarketingTitleFontSize: $esMarketingLargeFontSize;\r\n\r\n// margins and padding/\r\n$ezDefaultMarginSize: 0;\r\n$ezDefaultPaddingSize: 0;\r\n\r\n// Background Images\r\n.ezBackgroundImage {\r\n    background-image: linear-gradient(90deg, $ezBackgroundImageGradientAlphaWhite1 50%, transparent 50%),\r\n    linear-gradient(90deg, $ezBackgroundImageGradientAlphaWhite2 50%, transparent 50%),\r\n    linear-gradient(90deg, transparent 50%, $ezBackgroundImageGradientAlphaWhite3 50%),\r\n    linear-gradient(90deg, transparent 50%, $ezBackgroundImageGradientAlphaWhite4 50%);\r\n    background-size: 13px, 29px, 37px, 53px;\r\n}\r\n\r\n.ez-float-left {\r\n    float: left\r\n}\r\n\r\n.ez-float-right {\r\n    float: left\r\n}\r\n\r\n.ez-bring-to-front {\r\n    z-index: 9999;\r\n}\r\n\r\n.ez-hidden {\r\n    display: none;\r\n}\r\n\r\n.ez-topish {\r\n    margin-top: 25%;\r\n}\r\n\r\n.ez-full-width {\r\n    width: 100%;\r\n}\r\n","@use 'ez-core';\r\n@use 'ez-responsive.scss';\r\n\r\n//colors\r\n// $color_givry_approx: #f3e2c9;\r\n// $color_zanah_approx: #d9e4d3;\r\n// $color_shady_lady_approx: #a4a8a7;\r\n// $color_zeus_approx: #241f20;\r\n// $color_pampas_approx: #f7f4ec;\r\n// $gray: #808080;\r\n// $color_shark_approx: #282324;\r\n// $color_supernova_approx: #fec503;\r\n// $color_sunglow_approx: #fed136;\r\n// $ezClockerWhite;: #fff;\r\n// $color_bright_sun_50_approx: rgba(254, 209, 55, 0.5);\r\n// $color_romance_approx: #fdfdfd;\r\n// $color_french_gray_approx: #bbc0c5;\r\n// $color_submarine_approx: #bfc5c8;\r\n// $color_oslo_gray_approx: #8c9192;\r\n// $color_carrot_orange_approx: #f68c2b;\r\n// $color_pumice_approx: #c7c9ca;\r\n// $color_abbey_approx: #495057;\r\n// $ezClockerBlack: #000;\r\n// $color_california_approx: #f90;\r\n// $color_pale_sky_approx: #6a737d;\r\n// $color_mine_shaft_approx: #333;\r\n// $color_celeste_approx: #ccc;\r\n// $color_quill_gray_approx: #d2d1d1;\r\n// $color_alabaster_approx: #f9f9f9;\r\n// $color_science_blue_approx: #0077e2;\r\n// $color_scarlet_approx: #ef1a1a;\r\n// $color_cerulean_approx: #00aced;\r\n// $color_cabaret_approx: #d84b6b;\r\n//fonts\r\n$font_0: Droid Serif;\r\n$font_1: Helvetica Neue;\r\n$font_2: Helvetica;\r\n$font_3: Arial;\r\n$font_4: sans-serif;\r\n$font_5: Roboto;\r\n$font_6: Kaushan Script;\r\n$font_7: cursive;\r\n$font_8: Roboto; //Acme;\r\n$font_9: serif;\r\n\r\n//urls\r\n$url_0: url(/welcome/images/ezc_web_image_0_Home_2.jpg);\r\n$url_1: url(/welcome/images/clock_in_out_anywhere_banner.jpg);\r\n$url_2: url(/welcome/images/gps_verification_banner.jpg);\r\n$url_3: url(/welcome/images/online_scheduling_banner.jpg);\r\n\r\n.ezErrorBox {\r\n    display: none;\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n    padding-top: 4px;\r\n    padding-right: 4px;\r\n    padding-bottom: 4px;\r\n    padding-left: 28px;\r\n    min-height: 20px;\r\n    min-width: 20px;\r\n    background-color: #ffcccc;\r\n    background-image: url(\"/public/images/icons/error-red.svg\");\r\n    background-size: 20px 20px;\r\n    background-repeat: no-repeat;\r\n    background-position-x: 4px;\r\n    background-position-y: 4px;\r\n    background-clip: padding-box;\r\n    color: #000000;\r\n    font-size: 12pt;\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-color: #9b0400;\r\n}\r\n\r\n#appleAppStoreBadge {\r\n    height: 46px;\r\n}\r\n\r\ndiv.sign-in {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n// Sections\r\nsection {\r\n    background-color: ez-core.$ezAlphaBackgroundColor;\r\n    h2.section-heading {\r\n        font-size: ez-responsive.$ezResponsiveMarketingHeaderFontSize;\r\n        margin-top: 15px;\r\n        margin-bottom: 15px;\r\n        color: ez-core.$ezHeaderTextColor;\r\n    }\r\n    h3.section-subheading {\r\n        color: ez-core.$ezSubHeaderTextColor;\r\n        font-size: ez-responsive.$ezResponsiveMarketingSubHeaderFontSize;\r\n        margin-bottom: 75px;\r\n        text-transform: none;\r\n    }\r\n}\r\n\r\nimg::selection {\r\n    background: 0 0;\r\n}\r\n\r\nimg::-moz-selection {\r\n    background: 0 0;\r\n}\r\n\r\n.scrolled {\r\n    background-color: ez-core.$ezAlphaDarkBackgroundColor;\r\n    box-shadow: 0 0 2px 2px rgb(0 0 0 / 40%);\r\n}\r\n\r\n#mainNav {\r\n    .navbar-toggler {\r\n        font-size: 12px;\r\n        right: 0;\r\n        padding: 13px;\r\n        text-transform: uppercase;\r\n        color: ez-core.$ezClockerWhite;\r\n        border: 0;\r\n        background-color: ez-core.$ezClockerOrange;\r\n        font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n        margin-right: 10px;\r\n    }\r\n    .navbar-brand {\r\n        font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n        &:active {\r\n            color: ez-core.$ezClockerOrange;\r\n        }\r\n        &:focus {\r\n            color: ez-core.$ezClockerOrange;\r\n        }\r\n        &:hover {\r\n            color: ez-core.$ezClockerOrange;\r\n        }\r\n    }\r\n    .navbar-collapse {\r\n        background-color: ez-core.$ezDarkSmokeyTooth;\r\n        color: ez-core.$ezClockerBlack;\r\n        border-style: none;\r\n    }\r\n    .navbar-nav .nav-item {\r\n        text-align: right;\r\n        padding-right: 10px;\r\n        .nav-link {\r\n            font-size: ez-responsive.$ezResponsiveNormalFontSize;\r\n            padding: 0.75em 0;\r\n            letter-spacing: 1px;\r\n            color: ez-core.$ezClockerBlack;\r\n            font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n            &:active {\r\n                font-weight: bold;\r\n                color: ez-core.$ezDarkOrange;\r\n            }\r\n            &:focus {\r\n                font-weight: bold;\r\n                color: ez-core.$ezHoverOrange;\r\n            }\r\n            &:hover {\r\n                font-weight: bold;\r\n                color: ez-core.$ezHoverOrange;\r\n            }\r\n        }\r\n        .nav-link-scrolled {\r\n            font-size: ez-responsive.$ezResponsiveNormalFontSize;\r\n            padding: 0.75em 0;\r\n            letter-spacing: 1px;\r\n            color: ez-core.$ezClockerBlack;\r\n            font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n            &:active {\r\n                color: ez-core.$ezDarkOrange;\r\n            }\r\n            &:focus {\r\n                font-weight: bold;\r\n                color: ez-core.$ezHoverOrange;\r\n            }\r\n            &:hover {\r\n                color: ez-core.$ezHoverOrange;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n#ezcLogo {\r\n    max-height: 44px;\r\n    max-width: 150px;\r\n}\r\n\r\nsection.masthead {\r\n    text-align: center;\r\n    color: ez-core.$ezClockerBlack;\r\n    background-image: $url_0;\r\n    background-repeat: no-repeat;\r\n    background-attachment: scroll;\r\n    background-position-x: 75%;\r\n    background-size: cover;\r\n    .container {\r\n        margin-left: 2px;\r\n    }\r\n    .intro-text {\r\n        padding-top: 250px;\r\n        padding-bottom: 50px;\r\n        .intro-lead-in {\r\n            font-style: italic;\r\n            margin-bottom: 25px;\r\n            font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n        }\r\n        .intro-heading h4 {\r\n            font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n        }\r\n    }\r\n}\r\n\r\n#signup {\r\n    float: none;\r\n    margin: 0 auto;\r\n    padding-right: 25px;\r\n    padding-left: 25px;\r\n    .form-group {\r\n        width: 80%;\r\n        padding-left: 10px;\r\n    }\r\n    .card .card-block .row.col-lg-12 {\r\n        margin: 0;\r\n        padding: 10px;\r\n    }\r\n}\r\n\r\n#footersignin {\r\n    font-weight: 700;\r\n    padding-top: 10px;\r\n}\r\n\r\n.horz-image-section {\r\n    background-repeat: no-repeat;\r\n    background-attachment: scroll;\r\n    background-position: center top;\r\n    background-size: contain;\r\n}\r\n\r\n#horz-image-1 {\r\n    height: 180px;\r\n    background-image: $url_1;\r\n    background-position-x: 15%;\r\n    background-color: ez-core.$ezClockerBackground;\r\n    .horz-image-header {\r\n        padding-top: 100px;\r\n        padding-left: 5%;\r\n    }\r\n    .horz-image-text {\r\n        padding-top: 2px;\r\n        padding-left: 5%;\r\n    }\r\n}\r\n\r\n#horz-image-2 {\r\n    height: 230px;\r\n    margin-top: 0;\r\n    background-image: $url_2;\r\n    background-position-x: 70%;\r\n    background-color: ez-core.$ezClockerBackground;\r\n    .horz-image-header {\r\n        padding-top: 118px;\r\n        padding-left: 5%;\r\n    }\r\n    .horz-image-text {\r\n        padding-top: 0;\r\n        padding-left: 5%;\r\n    }\r\n}\r\n\r\n#horz-image-3 {\r\n    height: 220px;\r\n    margin-top: 0;\r\n    background-image: $url_3;\r\n    background-position-x: 15%;\r\n    background-color: ez-core.$ezClockerBackground;\r\n    .horz-image-header {\r\n        padding-top: 100px;\r\n        padding-left: 5%;\r\n    }\r\n    .horz-image-text {\r\n        padding-top: 0;\r\n        padding-left: 5%;\r\n    }\r\n}\r\n\r\n#ezMarketingVideo {\r\n    background-color: ez-core.$ezClockerBackground; //margin-top: 30px;\r\n    .container {\r\n        padding-top: 20px;\r\n    }\r\n}\r\n\r\n#video-col {\r\n    background-color: ez-core.$ezClockerBackground;\r\n    padding-left: 50px;\r\n    padding-right: 50px;\r\n    padding-bottom: 15px;\r\n}\r\n\r\n#ezClockerFeatures {\r\n    background-color: ez-core.$ezClockerWhite;\r\n    .container {\r\n        padding: 15px;\r\n        max-width: 90%;\r\n    }\r\n    .options-col {\r\n        padding-left: 3rem;\r\n        padding-right: 3rem;\r\n        padding-top: 10px;\r\n        padding-bottom: 25px;\r\n    }\r\n    .option-text-container {\r\n        text-align: justify;\r\n        margin-left: 1px;\r\n        padding-bottom: 30px;\r\n    }\r\n    .text-muted {\r\n        font-size: 0.8rem;\r\n    }\r\n    .learn-more {\r\n        margin-top: 10px;\r\n        border-style: solid;\r\n        border-width: 0.8px;\r\n        border-color: #fec503;\r\n        padding: 13px;\r\n        border-radius: 25px;\r\n    }\r\n    .learn-more:hover {\r\n        background-color: ez-core.$ezClockerYellow;\r\n        color: ez-core.$ezClockerBlack;\r\n    }\r\n}\r\n\r\n.filler-helper {\r\n    height: 100%;\r\n    vertical-align: middle;\r\n}\r\n.filler-image-middle {\r\n    height: 100%;\r\n    width: 100%;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n}\r\n\r\n#filler {\r\n    padding: 30px;\r\n    vertical-align: center;\r\n    background-color: ez-core.$ezClockerGray;\r\n    .col-md-3 {\r\n        vertical-align: middle;\r\n        margin-bottom: 30px;\r\n        &:last-child {\r\n            margin-bottom: 0;\r\n        }\r\n    }\r\n    img {\r\n        max-width: 140px;\r\n        max-height: 40px;\r\n    }\r\n}\r\n\r\n#ezClockerFeedback {\r\n    background-color: ez-core.$ezAlphaBackgroundColor;\r\n    .carousel-item {\r\n        padding-top: 15px;\r\n        padding-bottom: 15px;\r\n        h6 {\r\n            font-size: 1rem;\r\n            font-weight: 100;\r\n            font-style: italic;\r\n            font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n        }\r\n    }\r\n}\r\n\r\n.carousel-indicators {\r\n    .active {\r\n        background-color: ez-core.$ezClockerOrange;\r\n    }\r\n    li {\r\n        background-color: ez-core.$ezClockerOrange;\r\n    }\r\n}\r\n\r\n#ezcFeedbackCarousel {\r\n    margin-left: 2px;\r\n    margin-right: 2px;\r\n    background-color: ez-core.$ezClockerSmokeyTooth;\r\n}\r\n\r\n#feedbackItem {\r\n    padding-top: 20px;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    line-height: 1.2;\r\n    height: 250px;\r\n}\r\n\r\n#reviewername {\r\n    padding-top: 10px;\r\n    span {\r\n        padding-left: 10px;\r\n        font-size: 0.6rem;\r\n    }\r\n}\r\n\r\n.carousel-prev {\r\n    color: ez-core.$ezClockerOrange;\r\n}\r\n\r\n.carousel-next {\r\n    color: ez-core.$ezClockerOrange;\r\n}\r\n\r\n.collapse-span {\r\n    padding-left: 5px;\r\n}\r\n\r\n.service-heading {\r\n    margin: 15px 0;\r\n}\r\n\r\nfooter {\r\n    margin-top: 10px;\r\n    padding: 25px 0;\r\n    text-align: center;\r\n    span.copyright {\r\n        font-size: 90%;\r\n        line-height: 40px;\r\n        text-transform: none;\r\n        font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n    }\r\n    ul.quicklinks {\r\n        font-size: 90%;\r\n        line-height: 40px;\r\n        margin-bottom: 0;\r\n        text-transform: none;\r\n        font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n    }\r\n}\r\n\r\n#contact-us,\r\n#signupCard {\r\n    background-color: ez-core.$ezSilverAlpha;\r\n}\r\n\r\n#signupCardHeader {\r\n    background-color: ez-core.$ezClockerGray;\r\n}\r\n\r\n#signupText {\r\n    padding-top: 5px;\r\n}\r\n\r\n\r\n#signupbuttonrow {\r\n    padding-top: 10px;\r\n}\r\n\r\n.horz-filler {\r\n    padding: 10px;\r\n}\r\n\r\n#address {\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n    text-align: center;\r\n    background-color: ez-core.$ezClockerAquaGray;\r\n    color: ez-core.$ezClockerWhite;\r\n    font-size: 12pt;\r\n}\r\n\r\n#ezcFooter {\r\n    background-color: ez-core.$ezClockerAquaGray;\r\n    color: ez-core.$ezClockerWhite;\r\n    padding-top: 30px;\r\n    .footer-copyright {\r\n        background-color: ez-core.$ezDarkGray;\r\n        padding-top: 3px;\r\n        padding-bottom: 3px;\r\n        text-align: center;\r\n        p {\r\n            margin: 10px;\r\n            color: ez-core.$ezLightAquaGray;\r\n            font-size: 10pt;\r\n        }\r\n    }\r\n    .row {\r\n        margin-bottom: 60px;\r\n    }\r\n    .navbar-brand {\r\n        margin-top: 45px;\r\n        height: 65px;\r\n    }\r\n    ul {\r\n        list-style-type: none;\r\n        padding-left: 0;\r\n        line-height: 1.7;\r\n    }\r\n    h5 {\r\n        font-size: 18px;\r\n        color: ez-core.$ezClockerWhite;\r\n        font-weight: bold;\r\n        margin-top: 30px;\r\n    }\r\n    a {\r\n        color: ez-core.$ezClockerSilver;\r\n        text-decoration: none;\r\n        &:hover {\r\n            color: ez-core.$ezClockerWhite;\r\n        }\r\n        &:focus {\r\n            color: ez-core.$ezClockerWhite;\r\n        }\r\n    }\r\n    .social-networks {\r\n        text-align: center;\r\n        padding-top: 30px;\r\n        padding-bottom: 16px;\r\n        a {\r\n            font-size: 32px;\r\n            color: ez-core.$ezAquaGrayContainerText;\r\n            padding: 10px;\r\n            transition: 0.2s;\r\n            text-decoration: none;\r\n            &:hover {\r\n                color: ez-core.$ezClockerWhite;\r\n            }\r\n            &:focus {\r\n                color: ez-core.$ezClockerWhite;\r\n            }\r\n        }\r\n\r\n    }\r\n}\r\n\r\n#about-collapse[aria-expanded=false] .fa-chevron-up {\r\n    display: none;\r\n}\r\n\r\n#about-collapse[aria-expanded=true] .fa-chevron-down {\r\n    display: none;\r\n}\r\n\r\n#indus-collapse[aria-expanded=false] .fa-chevron-up {\r\n    display: none;\r\n}\r\n\r\n#indus-collapse[aria-expanded=true] .fa-chevron-down {\r\n    display: none;\r\n}\r\n\r\n#product-collapse[aria-expanded=false] .fa-chevron-up {\r\n    display: none;\r\n}\r\n\r\n#product-collapse[aria-expanded=true] .fa-chevron-down {\r\n    display: none;\r\n}\r\n\r\nul.social-buttons {\r\n    margin-bottom: 0;\r\n    li a {\r\n        display: block;\r\n        width: 40px;\r\n        height: 40px;\r\n        transition: all 0.3s;\r\n        color: ez-core.$ezClockerWhite;\r\n        border-radius: 100%;\r\n        outline: 0;\r\n        background-color: ez-core.$ezClockerSilver;\r\n        &:active {\r\n            background-color: ez-core.$ezClockerWhite;\r\n        }\r\n        &:focus {\r\n            background-color: ez-core.$ezClockerWhite;\r\n        }\r\n        &:hover {\r\n            background-color: ez-core.$ezClockerWhite;\r\n        }\r\n    }\r\n    .btn {\r\n        color: ez-core.$ezClockerWhite;\r\n        background-color: ez-core.$ezClockerOrange;\r\n        border-radius: 20px;\r\n        border: none;\r\n        width: 150px;\r\n        display: block;\r\n        margin: 0 auto;\r\n        margin-top: 10px;\r\n    }\r\n    h2 a {\r\n        font-size: 50px;\r\n        text-align: center;\r\n        color: ez-core.$ezClockerWhite;\r\n    }\r\n    .facebook:hover {\r\n        color: ez-core.$ezClockerWhite;\r\n    }\r\n    .google:hover {\r\n        color: ez-core.$ezClockerWhite;\r\n    }\r\n    .twitter:hover {\r\n        color: ez-core.$ezClockerWhite;\r\n    }\r\n}\r\n\r\n@media(min-width: 320px) {\r\n    section.masthead {\r\n        text-align: center;\r\n        color: ez-core.$ezClockerWhite;\r\n        background-image: $url_0;\r\n        background-repeat: no-repeat;\r\n        background-attachment: scroll;\r\n        background-position-x: 75%;\r\n        background-size: cover;\r\n        .container {\r\n            margin-left: 2px;\r\n        }\r\n        .intro-text {\r\n            padding-top: 250px;\r\n            padding-bottom: 50px;\r\n            .intro-lead-in {\r\n                font-style: italic;\r\n                margin-bottom: 25px;\r\n                font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n            }\r\n            .intro-heading h4 {\r\n                font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media(min-width:576px) {\r\n    section.masthead {\r\n        text-align: center;\r\n        color: ez-core.$ezClockerWhite;\r\n        background-image: $url_0;\r\n        background-repeat: no-repeat;\r\n        background-attachment: scroll;\r\n        background-position-x: 75%;\r\n        background-size: cover;\r\n        .container {\r\n            margin-left: 2px;\r\n        }\r\n        .intro-text {\r\n            padding-top: 250px;\r\n            padding-bottom: 50px;\r\n            .intro-lead-in {\r\n                font-style: italic;\r\n                margin-bottom: 25px;\r\n                font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n            }\r\n            .intro-heading h4 {\r\n                font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n            }\r\n        }\r\n    }\r\n    .navbar-collapse {\r\n        background-color: ez-core.$ezDarkSmokeyTooth;\r\n        color: ez-core.$ezClockerBlack;\r\n        border-style: solid;\r\n        border-color: ez-core.$ezClockerGray;\r\n        border-width: 1px;\r\n        border-radius: 4px;\r\n    }\r\n    #ezcFooter {\r\n        .collapse-link {\r\n            display: none;\r\n        }\r\n        .collapse {\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n\r\n@media(min-width:768px) {\r\n    section.masthead {\r\n        text-align: center;\r\n        color: ez-core.$ezClockerWhite;\r\n        background-image: $url_0;\r\n        background-repeat: no-repeat;\r\n        background-attachment: scroll;\r\n        background-position-x: 75%;\r\n        background-size: cover;\r\n        .container {\r\n            margin-left: 2px;\r\n        }\r\n        .intro-text {\r\n            padding-top: 250px;\r\n            padding-bottom: 50px;\r\n            .intro-lead-in {\r\n                font-style: italic;\r\n                margin-bottom: 25px;\r\n                font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n            }\r\n            .intro-heading h4 {\r\n                font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n            }\r\n        }\r\n    }\r\n    #ezcLogo {\r\n        max-height: 44px;\r\n        max-width: 200px;\r\n    }\r\n    section {\r\n        padding: 5% 0;\r\n        h2.section-heading {\r\n            font-size: 2rem;\r\n            margin-top: 0;\r\n            padding-bottom: 50px;\r\n        }\r\n    }\r\n    #signup {\r\n        margin-left: 25px;\r\n        padding-left: 5px;\r\n        padding-right: 5px;\r\n        h4 {\r\n            font-size: 1.3rem;\r\n        }\r\n    }\r\n    #horz-image-1 {\r\n        height: 230px;\r\n        background-image: $url_1;\r\n        background-position-x: 15%;\r\n        background-color: ez-core.$ezClockerBackground;\r\n        background-size: cover;\r\n        padding-top: 150px;\r\n        padding-bottom: 150px;\r\n        .horz-image-header {\r\n            padding-top: 0;\r\n            padding-left: 50%;\r\n        }\r\n        .horz-image-text {\r\n            padding-top: 5px;\r\n            padding-left: 50%;\r\n        }\r\n    }\r\n    #horz-image-2 {\r\n        height: 230px;\r\n        background-image: $url_2;\r\n        background-position: 70%;\r\n        background-color: ez-core.$ezClockerBackground;\r\n        background-size: cover;\r\n        padding-top: 150px;\r\n        padding-bottom: 150px;\r\n        .horz-image-header {\r\n            padding-top: 0;\r\n            padding-left: 2%;\r\n            padding-right: 60%;\r\n        }\r\n        .horz-image-text {\r\n            padding-top: 5px;\r\n            padding-left: 2%;\r\n            padding-right: 50%;\r\n        }\r\n    }\r\n    #horz-image-3 {\r\n        height: 230px;\r\n        background-image: $url_3;\r\n        background-position-x: 15%;\r\n        background-color: ez-core.$ezClockerBackground;\r\n        background-size: cover;\r\n        padding-top: 150px;\r\n        padding-bottom: 150px;\r\n        .horz-image-header {\r\n            padding-top: 0;\r\n            padding-left: 50%;\r\n        }\r\n        .horz-image-text {\r\n            padding-top: 5px;\r\n            padding-left: 50%;\r\n        }\r\n    }\r\n    #video-col {\r\n        padding-left: 150px;\r\n        padding-right: 150px;\r\n    }\r\n    #feedbackItem {\r\n        padding-top: 50px;\r\n        padding-left: 50px;\r\n        padding-right: 50px;\r\n        line-height: 1.2;\r\n        height: 250px;\r\n    }\r\n    #reviewername {\r\n        span {\r\n            font-size: 0.8rem;\r\n        }\r\n    }\r\n    #filler .col-md-3 {\r\n        margin-bottom: 0;\r\n    }\r\n    #video .container {\r\n        padding-top: 5px;\r\n        padding-bottom: 5px;\r\n    }\r\n    #ezClockerFeatures {\r\n        .container {\r\n            padding-top: 0;\r\n        }\r\n        .text-muted {\r\n            font-size: 1.0rem;\r\n        }\r\n    }\r\n    #ezClockerFeedback .carousel-item h6 {\r\n        font-size: 1.2rem;\r\n    }\r\n\r\n    .navbar-collapse {\r\n        background-color: ez-core.$ezDarkSmokeyTooth;\r\n        color: ez-core.$ezClockerBlack;\r\n        border-style: solid;\r\n        border-color: ez-core.$ezClockerGray;\r\n        border-width: 1px;\r\n        border-radius: 4px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n    #ezcFooter {\r\n        text-align: center;\r\n    }\r\n\r\n}\r\n\r\n@media screen and (min-width: 992px) {\r\n    #ezcFeedbackCarousel {\r\n        margin-left: 150px;\r\n        margin-right: 150px;\r\n        background-color: ez-core.$ezClockerSmokeyTooth;\r\n    }\r\n    #mainNav .container {\r\n        margin-left: 15px;\r\n        max-width: 100%;\r\n    }\r\n    #mainNav .navbar-nav .nav-item {\r\n        color: ez-core.$ezClockerWhite;\r\n    }\r\n    #mainNav .navbar-nav .nav-item .nav-link-scrolled {\r\n        font-size: ez-responsive.$ezResponsiveNormalFontSize;\r\n        padding: 0.75em 0;\r\n        letter-spacing: 1px;\r\n        color: ez-core.$ezClockerBlack;\r\n        font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n        &.active {\r\n            color: ez-core.$ezDarkOrange;\r\n        }\r\n        &:hover {\r\n            color: ez-core.$ezHoverOrange;\r\n        }\r\n    }\r\n    #mainNav .navbar-collapse {\r\n        background-color: transparent;\r\n    }\r\n    section.masthead {\r\n        background-position: right top;\r\n        padding-bottom: 10px;\r\n        .intro-text {\r\n            padding-top: 40px;\r\n            padding-bottom: 25px;\r\n            text-align: left;\r\n            .intro-heading {\r\n                //font-size: 75px;\r\n                //font-weight: 700;\r\n                //line-height: 75px;\r\n                margin-bottom: 40px;\r\n                font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n                color: ez-core.$ezClockerBlack;\r\n                .title-margin {\r\n                    margin-left: 15px; //margin-bottom: 25px;\r\n                }\r\n            }\r\n            .intro-lead-in {\r\n                font-size: 40px;\r\n                font-style: italic;\r\n                line-height: 40px;\r\n                margin-bottom: 25px;\r\n                font-family: ez-core.$ezFontFamilyRoboto, ez-core.$ezFontFamilyVerdana, ez-core.$ezFontFamilySansSerif;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .container {\r\n        max-width: 1140px;\r\n    }\r\n}\r\n\r\n\r\n/*------------------------------------------------------\r\n| @Media Small Mobile Devices\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (max-width: ez-responsive.$ezSmallMobileMaxWidth)  {\r\n}\r\n\r\n/*------------------------------------------------------\r\n| @Media for Regular Mobile Devices\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (min-width: ez-responsive.$ezMobileMinWidth) and\r\n    (max-width: ez-responsive.$ezMobileMaxWidth)  {\r\n}\r\n\r\n/*------------------------------------------------------\r\n| @Media for Tablets\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (min-width: ez-responsive.$ezTabletMinWidth) and\r\n    (max-width: ez-responsive.$ezTabletMaxWidth) {\r\n}\r\n\r\n/*------------------------------------------------------\r\n| @Media for Laptops\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (min-width: ez-responsive.$ezLaptopMinWidth) and\r\n    (max-width: ez-responsive.$ezLaptopMaxWidth) {\r\n}\r\n\r\n/*------------------------------------------------------\r\n| @Media for Desktops\r\n--------------------------------------------------------*/\r\n@media only screen and\r\n    (min-width: ez-responsive.$ezDesktopMinWidth) {\r\n        .navbar-collapse {\r\n        background-color: transparent;\r\n        color: ez-core.$ezClockerBlack;\r\n        border-style: none;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
